import React from 'react';
import './styles.css';
export var Button = function (_a) {
    var title = _a.title, onClick = _a.onClick;
    return (React.createElement("div", { className: 'btnContainer' },
        React.createElement("button", { className: 'primaryButton', onClick: onClick },
            React.createElement("p", null, title))));
};
